export const ADVISOR_NOTE_SEVERITIES = [
  "note",
  "warn",
  "alert",
  "suggestion",
] as const;
export const ADVISOR_NOTE_STATUSES = [
  "posted",
  "pending",
  "confirmed",
  "dismissed",
] as const;

type AdvisorNoteSeverityLiteral = (typeof ADVISOR_NOTE_SEVERITIES)[number];
type AdvisorNoteStatusLiteral = (typeof ADVISOR_NOTE_STATUSES)[number];

export const ADVISOR_NOTE_SEVERITY = {
  NOTE: "note",
  WARN: "warn",
  ALERT: "alert",
  SUGGESTION: "suggestion",
} as const satisfies {
  [Severity in AdvisorNoteSeverityLiteral as Uppercase<Severity>]: Severity;
};

export const ADVISOR_NOTE_STATUS = {
  POSTED: "posted",
  PENDING: "pending",
  CONFIRMED: "confirmed",
  DISMISSED: "dismissed",
} as const satisfies {
  [Status in AdvisorNoteStatusLiteral as Uppercase<Status>]: Status;
};

export const ADVISOR_ALERT_SOURCE = "advisor_alert";
export const ADVISOR_WARNING_SOURCE = "advisor_warning";
export const ADVISOR_SUGGESTION_SOURCE = "advisor_suggestion";
export const ADVISOR_TRANSCRIPT_SOURCE = "advisor_transcript";
export const ADVISOR_PASS_FAILURE_SOURCE = "advisor_pass_failure";
export const ADVISOR_ALERT_DELIVERY_FAILURE_SOURCE =
  "advisor_alert_delivery_failure";
export const ADVISOR_PASS_FAILURE_DEDUPE_KEY = "advisor-pass-failure-active";
export const ADVISOR_ALERT_DELIVERY_FAILURE_DEDUPE_KEY =
  "advisor-alert-delivery-failure";
export const ADVISOR_NOTE_EVENT_TYPE = "advisor_note";
export const ADVISOR_NOTE_PART_KIND = "advisor";
export const ADVISOR_WARN_NOTIFICATION_TYPE = "advisor_warn";
export const ADVISOR_ALERT_NOTIFICATION_TYPE = "advisor_alert";
export const ADVISOR_THROUGH_SEQUENCE_KEY = "advisorThroughSequence";
